module.exports = __webpack_public_path__ + "static/media/10S.51c55f09.svg";